<template>
    <div class="banner">
        <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000"
            fade
        >
            <b-carousel-slide v-if="pageName == 'home'">
                <img class="carousel-img h-[450px] md:h-[550px] lg:h-[650px]" slot="img" src="@/assets/img/home/homeBanner.jpg" alt="Banner">
            </b-carousel-slide>
            <b-carousel-slide v-if="pageName == 'home'">
                <img class="carousel-img h-[450px] md:h-[550px] lg:h-[650px]" slot="img" src="@/assets/img/thuydien.jpg" alt="Banner">
            </b-carousel-slide>
            <b-carousel-slide v-if="pageName == 'home'">
                <img class="carousel-img h-[450px] md:h-[550px] lg:h-[650px]" slot="img" src="@/assets/img/student/student-2.jpg" alt="Banner">
            </b-carousel-slide>
            <b-carousel-slide v-if="pageName == 'student-life'">
                <img class="carousel-img !h-[350px]" slot="img" src="@/assets/img/student/student-1.jpg" alt="Banner">
            </b-carousel-slide>
            <b-carousel-slide v-if="pageName == 'student-life'">
                <img class="carousel-img !h-[350px]" slot="img" src="@/assets/img/student/student-2.jpg" alt="Banner">
            </b-carousel-slide>
            <b-carousel-slide v-if="pageName == 'student-life'">
                <img class="carousel-img !h-[350px]" slot="img" src="@/assets/img/student/student-3.jpg" alt="Banner">
            </b-carousel-slide>
            <b-carousel-slide v-if="pageName == 'student-life'">
                <img class="carousel-img !h-[350px]" slot="img" src="@/assets/img/student/student.jpg" alt="Banner">
            </b-carousel-slide>
        </b-carousel>
        <div class="carousel-overlay" v-if="pageName == 'home' || pageName == 'about'">
            <div class="carousel-text text-light">
                <div data-aos="fade-up" data-aos-duration="1000" class="carouse-description mx-auto mx-md-0 d-md-flex text-center">
                    <i class='bx bx-md bx-current-location' ></i>
                    <p>Khoa Kỹ thuật & Công nghệ – Đại học Huế có sứ mạng đào tạo, nghiên cứu, chuyển giao khoa học và công nghệ, phục vụ cộng đồng, cung ứng nguồn nhân lực chất lượng cao các lĩnh vực kỹ thuật và công nghệ</p>
                </div>
                <button @click="()=>{this.$router.push({path: '/student-life'})}" data-aos="fade-up" data-aos-duration="1000" class="mx-auto mx-md-0">
                    <i class='bx bx-sm bx-trip'></i>
                    <h4 >Khám phá</h4>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {

    },
    created() {

    },
    computed: {
        pageName() {
            return this.$route.name.split('.')[1]
        }
    }
}
</script>

<style lang="scss" scoped>
.banner {
    position: relative;
    width: 100%;
    height: fit-content;
    background-color: transparent;
}
.carousel-overlay {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
}
.carousel-text {
    position: absolute;
    bottom: 20px;
    right: 0;
    left: 0;
    width: 100%;
    padding: 0px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    gap: 20px;
    button {
        border-radius: 100px;
        padding: 10px 20px;
        display: flex;
        gap: 16px;
        width: 200px;
        height: 50px;
        justify-content: center;
        align-items: center;
        transition: all 50ms;
        background-color: rgba(0, 0, 0, 0.218);
        border: white 2px solid;
        svg {
            fill: white;
        }
        h4 {
            margin-bottom: 0;
            color: white;
        }
        &:hover {
            gap: 2px;
        }
    }
    .carouse-description {
        align-items: center;
        gap: 8px;
        .bx-md {
            margin: auto;
            width: 60px;
            transition: transform 0.6s ease-in-out;
        }
        p {
            max-width: 300px;
            margin-bottom: 0;
            font-size: 20px;
            text-align: justify;
            text-shadow: 1px 1px 4px black;
        }
        &:hover {
            .bx-md {
                transform: rotate(540deg);
            }
        }
    }
}
img {
    position: relative;
    width: 100%;
    object-fit: cover;
    object-position: center;
}
@media screen and (min-width : 576px) {

}

@media screen and (min-width: 768px) {
    .carousel-text {
        bottom: 30px;
        padding: 0px 30px;
        flex-direction: row;
        justify-content: space-between;
        button {
            width: 180px;
            gap: 24px;
            padding: 10px 20px;
        }
        .carouse-description {
            p {
                max-width: 300px;
            }
        }
    }
}

@media screen and (min-width: 992px) {
    img {
        height: 630px;
    }
    .carousel-text {
        bottom: 50px;
        padding: 0px 50px;
        .carouse-description {
            p {
                max-width: 510px;
                font-size: 22px;
            }
        }
    }
}
</style>